const hy = {
  heading: 'UX Core',
  link: 'uxcore.io',
  description:
    ' Ամենամեծ անվճար հավաքածուն կոգնիտիվ հակումների (մտածողության օրինաչափություններ) ավելի քան 1000 կիրառության օրինակներով։',
  mainTitle: 'Հակման առաջացման միջավայր',
  moto: 'Be Kind. Do Good.',
  browsingAsProduct: 'Դուք դիտում եք կիրառությունները Պրոդուկտում',
  browsingAsHR: 'Դուք դիտում եք կիրառությունները ՄՌԿ-ում (HR)',
  browsingAsOffsec: 'You are viewing offensive security use cases',
  sectionTitles: [
    { color: 'purple', title: 'Ի՞նչ պետք է հիշել' },
    { color: 'pink', title: 'Պետք է արագ գործել' },
    { color: 'green', title: 'Անբավարար իմաստ' },
    { color: 'blue', title: 'Չափազանց շատ\nտեղեկատվություն' },
  ],
  legends: ['Product value', 'Management value'],

  explanationLink: {
    title: 'Նախագծի մասին',
    link: 'https://keepsimple.io/ru/articles/what-is-ux-core',
  },
};

export default hy;
